import validator from 'validator';

const E_VALID_EMAIL = 'Please enter a valid email address';

const isEmpty = (value) => validator.isEmpty(value, { ignore_whitespace: true });

export const validate = (email) => {
  var errors = {};

  if (isEmpty(email || '') || !validator.isEmail(email)) {
    errors.email = E_VALID_EMAIL;
  }

  return [!Object.getOwnPropertyNames(errors).length, errors];
};

export default validate;
